import { Linkedin, Lock } from 'lucide-react';

import { UpgradeButton } from '@/modules/billing/components/UpgradeButton';
import { IntegrationRow } from '@/modules/hiring-manager/components/IntegrationRow';

interface LockedLinkedInRowProps {
  /** Billing page link, including the tenant search when applicable. */
  to: string;
}

/**
 * The Integrations row a Free tenant sees instead of the connect card: the
 * plan carries no outreach account, so connecting could only fail. Mounted
 * through `FreePlanGate`.
 */
export function LockedLinkedInRow({ to }: LockedLinkedInRowProps) {
  return (
    <IntegrationRow
      action={
        <UpgradeButton
          className="h-8 rounded-md"
          size="sm"
          source="hm-integrations-channel"
          to={to}
          variant="outline"
        />
      }
      description="On Finlay Source, Finlay reaches candidates from your own LinkedIn profile, so they hear from you rather than from a tool."
      icon={Linkedin}
      name="LinkedIn"
      status={
        <span className="text-primary-700 bg-secondary-150 inline-flex h-5 items-center gap-1 rounded-full px-2 text-[11px] font-medium">
          <Lock aria-hidden className="size-3" />
          Finlay Source
        </span>
      }
    />
  );
}
